// extracted by mini-css-extract-plugin
export default {"wrapper":"AdvancedColorItem_wrapper__U+xKc","picker":"AdvancedColorItem_picker__nAo0L","titleWrapper":"AdvancedColorItem_titleWrapper__OV5KG"};